import { useMutation } from '@apollo/client'
import {
  SAVE_DECISION_EDIT_PAGE_DETAILS,
  SaveDecisionEditPageDetailsResponse,
  SaveDecisionEditPageDetailsVariables,
} from 'queries/mutations/save-decision-edit-page-details'

export const useSaveDecisionEditPageDetails = () => {
  const [saveDecisionEditPageDetails, { data, loading, error }] = useMutation<
    SaveDecisionEditPageDetailsResponse,
    SaveDecisionEditPageDetailsVariables
  >(SAVE_DECISION_EDIT_PAGE_DETAILS)

  return {
    saveDecisionEditPageDetails,
    data: data?.saveDecisionEditPageDetails,
    loading,
    error,
  }
}
